import { render, staticRenderFns } from "./EditPhysicalProductModal.vue?vue&type=template&id=5079f323"
import script from "./EditPhysicalProductModal.vue?vue&type=script&lang=js"
export * from "./EditPhysicalProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports